import axios from "axios";
import { UserData } from "../../hooks/FirstTimeWebSrn/Websrn";
import { ShowLoader } from '../actions/loader';

export const loginauth = (payload, server) => {
  console.log(payload, server)
  return async (dispatch) => {
    try {
      const createUrl = `${server}/apk/login`
      const res = await axios.post(createUrl, payload);

      if (res.status === 200) {
        dispatch(ShowLoader('0'))
        // console.log('Login successful');
        localStorage.setItem("User_Data", JSON.stringify(res.data));
        dispatch({
          type: 'FETCH_DATA_SUCCESS',
          response: res.data.token,
          userdata: res.data
        });
      } else {
        // console.error('Unexpected response:', res);
        dispatch({
          type: 'FETCH_DATA_ERROR',
          error: res.status,
          response: res.data
        });

        dispatch({
          type: 'SHOW_MODAL',
          response: res.data,
          status: '404'
        });
      }
    } catch (err) {
      dispatch(ShowLoader('0'))
      // console.error('Error during sami:', err.response.data);

    //   let errorStatus = err.response ? err.response.status : 'Unknown Error';
    //   let errorMessage = err.response ? err.response.data : 'Unknown Error';

    //   if (errorStatus === 401) {
    //     errorMessage = 'Invalid email or password';
    //   }

    //   dispatch({
    //     type: 'FETCH_DATA_ERROR',
    //     error: errorStatus,
    //     response: err.response.data
    //   });
      const er = {message: 'Network Error'}
      dispatch({
        type: 'SHOW_MODAL',
        response: err.code,
        status: '404'
      });
    }
  };
};

export const checklogin = () => {
  // console.log(UserData.token);
  
  // TODO: Add token validation logic here if needed

  return (dispatch) => {
    dispatch({
      type: 'FETCH_DATA_SUCCESS',
      response: UserData.token,
      userdata: UserData
    });
  };
};


export const Logout = (payload) => {
  return async(dispatch) =>{
      try{
          sessionStorage.clear();
          dispatch({type: 'TOKENNOTVALID' }) 
  }
  catch(err){
      dispatch({type: 'FETCH_DATA_ERROR' , error: 'server error'})
  }
  }
}